import { Box } from "@jewlr/storybook/core"
import loadable from "@loadable/component"
import React from "react"
import styled from "styled-components"

import useCollection from "areas/collection/hoc/use-collection"
import { retry } from "helpers/application"

const DescriptionMarkdown = loadable(() =>
  retry(() => import("./description-markdown"))
)

const Container = styled.div`
  background-color: ${(props) => props.theme.colors.subpolar};
  color: ${(props) => props.theme.colors.neutral};
  font-size: 16px;
  line-height: 1.2;
  padding: 24px 0;
  p {
    margin-bottom: 1em;
  }
`

const CollectionDescription = () => {
  const {
    data: { description, description_type: descriptionType } = {},
  } = useCollection()

  if (!description) return ""

  return (
    <Container>
      <Box contain px={2}>
        {descriptionType === "markdown" ? (
          <DescriptionMarkdown>{description}</DescriptionMarkdown>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: description }} />
        )}
      </Box>
    </Container>
  )
}

export default CollectionDescription
